'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _joiBrowser = require('joi-browser');

var _joiBrowser2 = _interopRequireDefault(_joiBrowser);

var _joiExtensions = require('../utilities/joiExtensions');

var _joiExtensions2 = _interopRequireDefault(_joiExtensions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _joiExtensions2.default.reduce(function (customJoi, extension) {
  return customJoi.extend(extension);
}, _joiBrowser2.default);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@blockcatio/tabby-library/lib/services/joi.js
// module id = 188
// module chunks = 0